import { ModuleRenderer } from "@/lib/contentful/modules/ModuleRenderer";
import type { PageDriverFieldsFragment } from "@/components/contentful/page-driver/__generated/page-driver.contentful.generated";
import { IntroContent } from "@/components/intro-content";
import { HeroSplitScreen } from "@/components/hero-layouts/hero-split-screen";
import { DriverHeaderDetails } from "./driver-header-details";
import { HeroTitleComponent } from "@/components/hero-layouts/hero-title-component";
import { DriverOverTitleComponent } from "./driver-over-title-component";
import { DriverUnderTitleComponent } from "./driver-under-title-component";

type PageDriverProps = PageDriverFieldsFragment;

export const PageDriver = (props: PageDriverProps) => {
    const { modulesCollection, driver, ...restProps } = props;

    return (
        <section>
            {driver && (
                <HeroSplitScreen
                    {...driver}
                    primaryComponent={
                        <HeroTitleComponent
                            title={driver.driverName}
                            isLight={false}
                            overTitleComponent={<DriverOverTitleComponent />}
                            underTitleComponent={<DriverUnderTitleComponent {...driver} />}
                        />
                    }
                    secondaryComponent={<DriverHeaderDetails {...driver} />}
                />
            )}
            <IntroContent {...restProps} />
            {modulesCollection?.items.map(
                (module, index) =>
                    module && (
                        <ModuleRenderer
                            componentProps={module}
                            key={module.sys.id + crypto.randomUUID()}
                            index={index}
                        />
                    )
            )}
        </section>
    );
};
